import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map, Observable } from 'rxjs';

import { PhoneInput } from '@models/phone-input.model';

@Injectable({
  providedIn: 'root',
})
export class PhoneInputService {
  private http = inject(HttpClient);

  public phoneCodes$?: Observable<PhoneInput>;

  getPhoneCodes(): Observable<PhoneInput> {
    if (this.phoneCodes$) return this.phoneCodes$;
    this.phoneCodes$ = this.http.get<any>('/data/phone-country-codes.json').pipe(
      map((response: PhoneInput) => {
        for (let item of response.countries) {
          item.image = 'images/flags/' + item.code.toLowerCase() + '.svg';
        }
        return response;
      }),
    );

    return this.phoneCodes$;
  }
}
